// Dashboard.jsx

import { Box, Grid, Typography, CircularProgress } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { tokens } from "../../../theme/theme";

import MachineBarChart from "./ProdMachineBarchart";
import ProductionPieChart from "./ProdProductionPieChart";
import useDashboardData from "./useProdDashboardData";
import SubscriptionCard from "./ProdSubscriptionCard";




export default function ProductionDashboard() {

  const { data, loading } = useDashboardData();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  if (loading || !data) {
    return (
      <Box p={4} display="flex" justifyContent="center" alignItems="center">
        <CircularProgress />
      </Box>
    );
  }

  const startDate = data?.subscription?.start_date
    ? new Date(data.subscription.start_date)
    : null;

  const expiryDate = data?.subscription?.expiry_date
    ? new Date(data.subscription.expiry_date)
    : null;

  let daysLeft = 0;
  let totalDays = 1; // avoid dividing by zero

  if (startDate && expiryDate && !isNaN(startDate) && !isNaN(expiryDate)) {
    const now = new Date();
    daysLeft = Math.max(
      0,
      Math.ceil((expiryDate - now) / (1000 * 60 * 60 * 24))
    );

    totalDays = Math.ceil((expiryDate - startDate) / (1000 * 60 * 60 * 24));
  }

  return (
    <Box p={3}>
      <Typography variant="h5" sx={{ fontWeight: 800, mb: 3 }}>
        Production Dashboard
      </Typography>

      <Grid container spacing={3}>

        {/* Subscription */}
        <Grid item xs={12} md={4}>
          <SubscriptionCard data={data} colors={colors} daysLeft={daysLeft} totalDays={totalDays} />
        </Grid>

        {/* Production KPI Cards */}
        <Grid item xs={12} md={8}>
          <Grid container spacing={2}>
            {[
              {
                title: "Total Parent Roll Booking Today",
                value: data.production.mo_released_today,
                bg: colors.primary[400],
                text: colors.grey[100],
              },
              {
                title: "Child Roll Produced Today",
                value: data.production.planned_qty,
                bg: colors.greenAccent[600],
                text: colors.grey[900],
              },
              {
                title: "Produced Reels",
                value: data.production.produced_reels,
                bg: colors.orangeAccent[500],
                text: colors.grey[900],
              },
              {
                title: "Produced Reams",
                value: data.production.produced_reams,
                bg: colors.purpleAccent[500],
                text: colors.grey[100],
              },
              {
                title: "Bundle ",
                value: data.production.produced_bundle_pallet,
                bg: colors.yellowAccent[600],
                text: colors.grey[900],
              },
              {
                title: "Ream Pallet",
                value: data.production.produced_bundle_pallet,
                bg: colors.greenAccent[600],
                text: colors.grey[900],
              },
             
            ].map((item, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Box
                  sx={{
                    backgroundColor: item.bg,
                    color: item.text,
                    borderRadius: 3,
                    padding: 2.5,
                    boxShadow: 3,
                    height: "110px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    transition: "all 0.25s ease",
                    cursor: "pointer",
                    "&:hover": {
                      transform: "scale(1.04)",
                      boxShadow: 6,
                    },
                  }}
                >
                  <Typography variant="body2" sx={{ opacity: 0.85 }}>
                    {item.title}
                  </Typography>
                  <Typography
                    variant="h4"
                    sx={{ fontWeight: 700, mt: 1, letterSpacing: 0.5 }}
                  >
                    {item.value ?? 0}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Grid>


        {/* Sales & Warehouse */}        
        {/* <Grid item xs={12} md={4}>
          <Box
            sx={{
              backgroundColor: colors.redAccent[500],
              color: colors.grey[100],
              borderRadius: 3,
              padding: 2.5,
              boxShadow: 3,
              height: "120px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              transition: "all 0.25s ease",
              cursor: "pointer",
              "&:hover": {
                transform: "scale(1.04)",
                boxShadow: 6,
              },
            }}
          >
            <Typography variant="body2" sx={{ opacity: 0.85 }}>
              New Orders Today
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: 700, mt: 1 }}>
              {data.sales.new_orders_today ?? 0}
            </Typography>
          </Box>
        </Grid> */}

        {/* RIGHT SIDE – 3 KPI BOXES */}
        {/* <Grid item xs={12} md={8}>
          <Grid container spacing={2}>
            
            <Grid item xs={12} sm={4}>
              <Box
                sx={{
                  backgroundColor: colors.blueAccent[500],
                  color: colors.grey[100],
                  borderRadius: 3,
                  padding: 2.5,
                  boxShadow: 3,
                  height: "120px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  transition: "all 0.25s ease",
                  cursor: "pointer",
                  "&:hover": {
                    transform: "scale(1.04)",
                    boxShadow: 6,
                  },
                }}
              >
                <Typography variant="body2" sx={{ opacity: 0.85 }}>
                  Reels Received
                </Typography>
                <Typography variant="h4" sx={{ fontWeight: 700, mt: 1 }}>
                  {data.warehouse.reels_received ?? 0}
                </Typography>
              </Box>
            </Grid>

            
            <Grid item xs={12} sm={4}>
              <Box
                sx={{
                  backgroundColor: colors.greenAccent[500],
                  color: colors.grey[900],
                  borderRadius: 3,
                  padding: 2.5,
                  boxShadow: 3,
                  height: "120px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  transition: "all 0.25s ease",
                  cursor: "pointer",
                  "&:hover": {
                    transform: "scale(1.04)",
                    boxShadow: 6,
                  },
                }}
              >
                <Typography variant="body2" sx={{ opacity: 0.85 }}>
                  Bundles Received
                </Typography>
                <Typography variant="h4" sx={{ fontWeight: 700, mt: 1 }}>
                  {data.warehouse.bundles_received ?? 0}
                </Typography>
              </Box>
            </Grid>

            
            <Grid item xs={12} sm={4}>
              <Box
                sx={{
                  backgroundColor: colors.primary[400],
                  color: colors.grey[100],
                  borderRadius: 3,
                  padding: 2.5,
                  boxShadow: 3,
                  height: "120px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  transition: "all 0.25s ease",
                  cursor: "pointer",
                  "&:hover": {
                    transform: "scale(1.04)",
                    boxShadow: 6,
                  },
                }}
              >
                <Typography variant="body2" sx={{ opacity: 0.85 }}>
                  Ream Pallets
                </Typography>
                <Typography variant="h4" sx={{ fontWeight: 700, mt: 1 }}>
                  {data.warehouse.ream_pallet_received ?? 0}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Grid> */}


        


        {/* Charts */}
        <Grid item xs={12} md={8}>
          <MachineBarChart data={data.machine_production} />
        </Grid>

        <Grid item xs={12} md={4}>
          <ProductionPieChart production={data.production} />
        </Grid>
      </Grid>
    </Box>
  );
}
